import { render, staticRenderFns } from "./BaseButtonInMedicalContent.vue?vue&type=template&id=1b307cfc&scoped=true&"
import script from "./BaseButtonInMedicalContent.vue?vue&type=script&lang=js&"
export * from "./BaseButtonInMedicalContent.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonInMedicalContent.vue?vue&type=style&index=0&id=1b307cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b307cfc",
  null
  
)

export default component.exports